import { render, staticRenderFns } from "./SelectComision.vue?vue&type=template&id=75bfbe79&"
import script from "./SelectComision.vue?vue&type=script&lang=js&"
export * from "./SelectComision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports